import { render, staticRenderFns } from "./GeneralUserView.vue?vue&type=template&id=44f52f0a&scoped=true"
import script from "./GeneralUserView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneralUserView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GeneralUserView.vue?vue&type=style&index=0&id=44f52f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f52f0a",
  null
  
)

export default component.exports